import { actions } from './actions';
import { mutations } from '@/store/public/company/mutations';
var state = {
    company: null,
    loading: false,
};
export var publicCompany = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
};
